import { Color, Flex, NavListItemText, Spacing } from '@billy/design-system'
import { ReactNode } from 'react'

import * as Styled from './styles'

interface NavigationMenuLabelProps {
  badge?: ReactNode
  label: string
  textColor?: Color
  isNotSubItem?: boolean
  wrap?: boolean
}

export const NavigationMenuLabel = ({
  badge,
  textColor,
  label,
  isNotSubItem = false,
  wrap = false,
}: NavigationMenuLabelProps) => (
  <Flex alignItems="center" justifyContent="space-between" width="100%" gap={badge ? Spacing.S4 : undefined}>
    <Styled.LabelWrapper $wrap={wrap}>
      <NavListItemText color={textColor} selectable={false} weight={isNotSubItem ? 'bold' : 'medium'} truncate={!wrap}>
        {label}
      </NavListItemText>
    </Styled.LabelWrapper>
    {badge && <Styled.BadgeWrapper>{badge}</Styled.BadgeWrapper>}
  </Flex>
)
